import React from 'react'

import { Alert } from '@mui/material'

const NoAccess = () => {
    return (<Alert severity="error">Sorry, you do not have permission to access this page.</Alert>)
}

export default NoAccess